import session_storage from 'modules/env/session';

const CONTACT_LIST = 'contact-list';
export function create(container) {
    let args = Array.prototype.slice.call(arguments, 1),
        toggleClass = args[0],
        ladyId = args[1];

    function checkContacts(){
        let contacts = session_storage.getItem(CONTACT_LIST);
        if(contacts && ladyId && contacts.hasOwnProperty(ladyId) && container.hasClass(toggleClass)){
            container.removeClass(toggleClass);
        }
    }

    checkContacts();

    setInterval(function(){
        checkContacts();
    },5000);


}

